class CollectionViewSwitcher extends HTMLElement {
  constructor() {
    super();
    this.gridBtns = this.querySelectorAll('.collection-view-toggle__btn--grid');
    this.listBtns = this.querySelectorAll('.collection-view-toggle__btn--list');

    this._bindEvents();

    const savedView = localStorage.getItem('collectionView') || 'grid';

    // ✅ On page load, update layout + buttons
    this._applyLayout(savedView);
    this._updateButtonUI(savedView);
  }

  _bindEvents() {
    this.gridBtns.forEach((btn) => btn.addEventListener('click', () => this._onViewChange('grid')));

    this.listBtns.forEach((btn) => btn.addEventListener('click', () => this._onViewChange('list')));

    // ✅ Listen to sync event from other switchers
    window.addEventListener('collectionViewChanged', (e) => {
      const view = e.detail.view;
      this._updateButtonUI(view);
    });
  }

  _onViewChange(view) {
    // ✅ Store in localStorage
    localStorage.setItem('collectionView', view);

    // ✅ Apply layout globally
    this._applyLayout(view);

    // ✅ Notify all switchers to update buttons
    window.dispatchEvent(
      new CustomEvent('collectionViewChanged', {
        detail: { view },
      })
    );
  }

  _applyLayout(view) {
    const productContainer = document.querySelector('#collection-products');
    const productGrid = document.getElementById('product-grid');
    if (!productContainer || !productGrid) return;

    if (view === 'grid') {
      productContainer.classList.remove('collection--list');
      productContainer.classList.add('collection--grid');
      productGrid.classList.remove('grid--list-view');
    } else {
      productContainer.classList.remove('collection--grid');
      productContainer.classList.add('collection--list');
      productGrid.classList.add('grid--list-view');
    }
  }

  _updateButtonUI(view) {
    if (view === 'grid') {
      this._setActiveButton(this.gridBtns, this.listBtns);
    } else {
      this._setActiveButton(this.listBtns, this.gridBtns);
    }
  }

  _setActiveButton(activeBtns, inactiveBtns) {
    activeBtns.forEach((btn) => btn.classList.add('active'));
    inactiveBtns.forEach((btn) => btn.classList.remove('active'));
  }
}

customElements.define('collection-view-switcher', CollectionViewSwitcher);
